import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.m.css";
import { get } from "lodash";
import HomePageMagazineCard from "../../../../../atoms/magazine-homepage-card";

const MagazineListCard = ({ collection, className = "" }) => {
  const story = get(collection, ["trending", "items", "magazine"], {});

  const config = get(collection, ["config"], {});
  if (!story) {
    return null;
  }

  let stacks =
    story &&
    story.map((item, index) => {
      return <HomePageMagazineCard collection={item} key={index} className={styles.card} config={config} />;
    });

  if (!stacks || !stacks.length) {
    return null;
  }
  return (
    <div className={`${styles["base"]}`}>
      <div className={styles["carousel-wrapper"]}>{stacks}</div>
    </div>
  );
};

MagazineListCard.propTypes = {
  className: PropTypes.string,
  config: PropTypes.object,
  collection: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    items: PropTypes.array
  }),
  numberOfCardsInViewDesktop: PropTypes.number,
  numberOfCardsInViewTablet: PropTypes.number,
  numberOfCardsInViewMobile: PropTypes.number
};

export default MagazineListCard;
